export type MedicalServiceSettlementType = 'None' | 'Proportional' | 'Fixed';
export const SETTLEMENT_TYPES: MedicalServiceSettlementType[] = ['None', 'Proportional', 'Fixed'];

export type MedicalServiceSettlementNoneType = {
   type: 'None';
   fixedValue?: never;
   proportionalValue?: never;
};

export type MedicalServiceSettlementFixedType = {
   type: 'Fixed';
   fixedValue: number | null;
   proportionalValue?: never;
};

export type MedicalServiceSettlementProportionalType = {
   type: 'Proportional';
   fixedValue?: never;
   proportionalValue: number | null;
};

export type MedicalServiceSettlementTypeVisitor = <ACCEPT>(
   visitor:
      | ((type: MedicalServiceSettlementType) => ACCEPT)
      | Record<`visit${MedicalServiceSettlementType}`, () => ACCEPT>
) => ACCEPT;
